import {Component, OnDestroy, OnInit} from '@angular/core';
import {SidebarCommon} from '../../../@core/common/sidebar';
import {ApiService} from '../../../@core/service/api.service';
import {UserModel} from '../../../@models';
import {Observable} from 'rxjs';
import {NbToastrService} from '@nebular/theme';
import {FormListCheckboxRendererComponent} from '../../shared/form-list/renderer/form-list-checkbox-renderer.component';
import {RegionModel} from '../../../@models/region';

@Component({
    selector: 'ngx-administration-region',
    templateUrl: './administration-region.component.html',
    styleUrls: ['./administration-region.component.scss']
})
export class AdministrationRegionComponent extends SidebarCommon<RegionModel> implements OnInit, OnDestroy {

  regions: Observable<RegionModel[]>;
  selected: RegionModel;

  public businessColumns = {
    region: {
      title: 'Business',
      type: 'string',
    },
    read: {
      title: 'Read',
      type: 'custom',
      renderComponent: FormListCheckboxRendererComponent,
      editor: {
        type: 'checkbox',

      },
    },
    write: {
      title: 'Write',
      type: 'custom',
      renderComponent: FormListCheckboxRendererComponent,
      editor: {
        type: 'checkbox',
        config: {
          true: true,
          false: false,
        },
      },
    },
    admin: {
      title: 'Admin',
      type: 'custom',
      renderComponent: FormListCheckboxRendererComponent,
      editor: {
        type: 'checkbox',
        config: {
          true: true,
          false: false,
        },
      },
    },
  };

  ////////////////////////////////////////////////////////////////////////////

  p: number = 1;

  ////////////////////////////////////////////////////////////////////////////

  constructor(private api: ApiService, private toastrService: NbToastrService) {
    super();
  }

  ngOnInit(): void {
    this.regions = this.api.reloadRegions();
  }

  ngOnDestroy(): void {
  }

  cancel(item: RegionModel) {
    this.hideSidebar();
  }

  save(item: RegionModel) {
    this.hideSidebar();
    this.api.saveRegion(item)
      .subscribe((i) => this.toastrService.success(`Region '${i.name}' saved!`, 'Success'));
  }
}
